import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface ChatAttachmentOptionProps {
  icon: FC<{ className?: string }>
  label: string
  description: string
  onClick: () => void
}

/**
 * Option button for the attachment sheet showing an icon, label, and description.
 */
export const ChatAttachmentOption: FC<ChatAttachmentOptionProps> = ({
  icon: Icon,
  label,
  description,
  onClick,
}): ReactNode => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      'chat-attachment-option flex w-full items-center gap-4 rounded-lg p-4 text-left',
      'transition-colors hover:bg-accent active:bg-accent/80'
    )}
  >
    <div className="flex size-12 shrink-0 items-center justify-center rounded-full bg-muted">
      <Icon className="size-6 text-muted-foreground" />
    </div>
    <div className="min-w-0 flex-1">
      <p className="font-medium">{label}</p>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  </button>
)

ChatAttachmentOption.displayName = 'ChatAttachmentOption'
